import {DocumentData} from "firebase/firestore";
import {Plan} from "@/model/User";

/**
 * The plan of an active users/{uid}/subscriptions document, in the shape the
 * Stripe webhook writes it (functions/src/Stripe/records.ts).
 */
export function planFromSubscription(subscription: DocumentData): Plan {
    return {
        id: subscription.items[0].plan.product,
        name: subscription.items[0].price.product.name,
        metadata: subscription.items[0].price?.product?.metadata,
        monthly_credit: subscription.items[0].plan?.transform_usage?.divide_by || Infinity,
        period_end: new Date(subscription.current_period_end.seconds * 1000),
        // The plan ends instead of renewing. Since the endive API a cancellation in the
        // customer portal sets cancel_at and leaves cancel_at_period_end false; documents
        // the extension stored before the cutover carry cancel_at_period_end.
        cancel_at_period_end: subscription.cancel_at_period_end === true || Boolean(subscription.cancel_at)
    } as Plan;
}
